import API from './API';

const path = `tratamentos/documentos`;

const DocumentoService = {
    
    filters: async filters => await API.filters(path, filters),

    next: async () => await API.list(`${path}/proximo`),

    clean: async () => await API.list(`${path}/limpar-fila`),
}

export default DocumentoService;

